export default {
  path: '/ratio-shares',
  meta: {
    title: '股票积分',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-shares`),
}



// WEBPACK FOOTER //
// ./src/views/RatioShares/router.js